export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-gradient-to-br from-foreground-900 via-foreground-950 to-foreground-900"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50 z-10"></div>

      <div
        className="absolute inset-0 z-0 opacity-25"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20gradient%20tones%20of%20coral%20rose%20and%20deep%20charcoal%2C%20floating%20geometric%20film%20strip%20shapes%20and%20light%20particles%2C%20atmospheric%20depth%2C%20modern%20entertainment%20art%20style%2C%20luxurious%20texture%2C%20cinematic%20lighting%20with%20subtle%20lens%20flares%2C%20dark%20elegant%20background%20with%20warm%20accents&width=1600&height=900&seq=hero-bg-peach-01&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-20 w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center gap-2 mb-5 justify-center lg:justify-start">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-300 border border-primary-500/30 whitespace-nowrap">
                每日更新
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap">
                海量资源
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-300 border border-primary-500/30 whitespace-nowrap">
                永久免费
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-3">
              桃子影院
              <span className="block text-primary-400 text-2xl md:text-3xl lg:text-4xl mt-1">高清影视在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-accent-400 font-heading mb-6">
              国产剧·韩剧·美剧 全部免费 不缓冲秒开
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              桃子影院汇聚海量高清电视剧资源，涵盖国产剧、韩剧、美剧等热门分类，每日同步更新最新剧集。
              采用领先的CDN加速技术，实现超清蓝光4K画质秒开不缓冲，为您带来极致的追剧体验。
              无需注册、无需付费，永久免费畅享万部精彩影视内容。
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-8 justify-center lg:justify-start mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">10000+</div>
                <div className="text-xs text-background-300/70 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-500/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日50+</div>
                <div className="text-xs text-background-300/70 mt-1">剧集更新</div>
              </div>
              <div className="w-px h-10 bg-background-500/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">99.9%</div>
                <div className="text-xs text-background-300/70 mt-1">在线稳定</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                开始观看
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-md text-sm border border-background-50/25 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                热门推荐
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-foreground-800/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20streaming%20platform%20interface%20design%2C%20floating%20drama%20posters%20and%20film%20elements%20with%20warm%20coral%20and%20golden%20accents%2C%20modern%20minimal%20UI%20with%20play%20buttons%20and%20rating%20stars%2C%20abstract%20geometric%20shapes%2C%20soft%20atmospheric%20lighting%2C%20luxurious%20dark%20theme%20with%20rose%20gold%20highlights%2C%20depth%20and%20dimension%20effect%2C%20editorial%20digital%20art%20quality&width=800&height=600&seq=hero-visual-peach-02&orientation=landscape"
                alt="桃子影院高清影视在线观看平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}